import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as LoginImage } from "../Images/login-image.svg";
import LogoSVG from "../Images/QP_Logo 3.png"
import EmailInputField from "../reusableField/EmailInputField";
import TextInputField from "../reusableField/TextInputField";
import { Col } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { emailRegex, passwordRegex } from "../regex/regex";
import { BASE_URL } from "./apiConfig";
import "./LoginPage.css";

const LoginPage = ({ setIsAuthenticated }) => {
    const [loginId, setLoginId] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("");
    const [loginLoading, setLoginLoading] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");

    const inputRefActivity = useRef(null);

    useEffect(() => {
        if (inputRefActivity.current) {
            inputRefActivity.current.focus();
        }
    }, []);


    const navigate = useNavigate();
    const appKey = "7cb80ffc8df6a5bf488e69f001ee0ab3";
    const validateEmail = () => {
        // Reject leading or trailing spaces
        if (loginId !== loginId.trim()) {
            setEmailError("Email should not contain leading or trailing spaces.");
            return false;
        }

        if (!emailRegex.test(loginId)) {
            setEmailError("Please enter a valid email.");
            return false;
        }

        return true;
    };

    const handleLogin = async (event) => {
        event.preventDefault();
        setMessage("");
        setEmailError("");
        setPasswordError("");

        let valid = true;
        if (!loginId) {
            setEmailError("Please enter your email.");
            valid = false;
        } else if (loginId !== loginId.trim()) {
            setEmailError("Email should not contain leading or trailing spaces.");
            valid = false;
        }

        if (!password) {
            setPasswordError("Please enter your password.");
            valid = false;
        }

        if (!valid) return;

        if (!validateEmail()) return;

        setLoginLoading(true);

        try {
            const response = await fetch(`${BASE_URL}user_validate`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ username: loginId.trim(), password, appkey: appKey, session: "12434" }),
            });

            if (response.ok) {
                const data = await response.json();
                localStorage.setItem("flutter.accessToken", data.access_token);
                setIsAuthenticated(true);
                navigate("/dashboard");
            } else {
                const errorData = await response.json();
                setMessage(errorData.detail || "Email or Password is incorrect.");
                setMessageType("error");
            }

        } catch (error) {
            setMessage("Error: Unable to log in. Please try again.");
            setMessageType("error");
        } finally {
            setLoginLoading(false);
        }
    };

    return (
        <div className="background-color">
            <div className="login-container">
                <div className="wrapper-container">
                    <div className="illustration-container">
                        <LoginImage className="illustration" />
                    </div>
                    <div className="form-container">
                        <div className="borders">
                            <img src={LogoSVG} className="icon2" />
                            <p className="welcome-text">Welcome</p>

                            <form className="login-form" onSubmit={handleLogin}>
                                <div className="form-group">
                                    <label className="loginLable" style={{ fontSize: "13px", color: "#1C1B1F" }}>Login ID</label>
                                    <Col sm={12} xs={12} md={12} lg={12}>
                                        <EmailInputField
                                            name="Email"
                                            placeholder="Enter Login ID "
                                            type="email"
                                            value={loginId}
                                            onChange={(e) => {
                                                setLoginId(e.target.value);
                                                setEmailError("");
                                                setMessage("");
                                            }}
                                            feedbackMessage="Please enter Email."
                                            validationRegex={emailRegex}
                                            validationErrorMessage="Please enter a valid Email."
                                        />
                                        {emailError && <p className="emailandpassword-error-message">{emailError}</p>}
                                    </Col>
                                </div>
                                <div className="form-group">
                                    <label className="loginLable" style={{ fontSize: "13px", color: "#1C1B1F" }}>Password</label>
                                    <Col sm={12} xs={12} md={12} lg={12}>
                                        <div className="password-field-container">
                                            <TextInputField
                                                placeholder="Enter Password"
                                                name="password"
                                                type={passwordVisible ? "text" : "password"}
                                                value={password}
                                                onChange={(e) => {
                                                    setPassword(e.target.value);
                                                    setPasswordError("");
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleLogin(e);
                                                    }
                                                }}
                                                autoComplete="new-password"
                                                feedbackMessage="Please enter your password."
                                                validationRegex={passwordRegex}
                                            // validationErrorMessage="Password is required."
                                            />
                                            {passwordError && <p className="emailandpassword-error-message">{passwordError}</p>}
                                            {password && (
                                                <span
                                                    className="eye-icon"
                                                    onClick={() => setPasswordVisible(!passwordVisible)}
                                                >
                                                    {passwordVisible ? <FaEye /> : <FaEyeSlash />}
                                                </span>
                                            )}
                                        </div>
                                    </Col>
                                </div>
                                {message && <p className={`backend-error-message ${messageType}`}>{message}</p>}
                                <div className="submit-container">
                                    <button type="submit" className="submit-btn" disabled={loginLoading}>
                                        {loginLoading ? "Loading..." : "Submit"}
                                    </button>
                                </div>
                                <div>
                                    <p className="forget-password">Forget Password?&nbsp;<span onClick={() => navigate("/forgot-password")} className="forget-password-click-here">Click Here</span></p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
